export default function floorPlanLoaded(state, action) {
  return Object.assign({}, state, {
    floorPlansLoaded: state.floorPlansLoaded + 1
  })
}



// WEBPACK FOOTER //
// ./src/reducers/floorPlanLoaded.js